import { useTranslation } from "react-i18next";

import { useDeleteSupplier, type Supplier } from "@/api/suppliers";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  supplier: Supplier | null;
  onClose: () => void;
}

export function DeleteSupplierDialog({ supplier, onClose }: Props) {
  const { t } = useTranslation();
  const del = useDeleteSupplier();

  if (!supplier) return null;

  async function handleDelete() {
    await del.mutateAsync(supplier!.id);
    onClose();
  }

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("suppliers.delete.title", { name: supplier.name })}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm">{t("suppliers.delete.confirm")}</p>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            {t("common.buttons.cancel")}
          </Button>
          <Button
            variant="destructive"
            disabled={del.isPending}
            onClick={handleDelete}
          >
            {t("common.buttons.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
